import $ from 'jquery';
import './layer.scss';
import Sloth from '../Sloth';
import layer from './layer/layer';
import './layer/theme/default/layer.css';

@Sloth.component({
    defaultOptions:{
        rangesearch: false,
        title: '内训师介绍',
        type: 1
    }
})

export default class Layer {
    onInit() {
        const dom = this.dom;
        const options = this.options;
        const mark = options.targetmark;
        const rangesearch = options.rangesearch;
        const targetObj = rangesearch ? $(mark, dom) : $(mark);
        const _title = options.title;

        let index;
        $(dom).on('click', () => {
            if (options.type === 2) {
                layer.open({
                    type: 2,
                    skin: 'layer-yhyh-iframe',
                    title: _title,
                    shade: 0.8,
                    area: ['987px', '80%'],
                    content: options.url
                });
            }
            if (options.type === 1) {
                const html = targetObj.html();
                index = layer.open({
                    type: 1,
                    skin: 'layer-yhyh',
                    title: _title,
                    closeBtn: 1,
                    anim: 2,
                    area: options.width,
                    shadeClose: false,
                    content: html
                });
            }

            return false;
        });

        $('.cancel', options.dom).on('click', () => {
            // ('input,textarea', options.dom).each(() => {
            //     this.value = '';
            // });
            layer.close(index);
            return false;
        });
    }
}



/** WEBPACK FOOTER **
 ** ./components/Layer/layer.js
 **/